var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 0.666504H2.33334C1.41667 0.666504 0.675005 1.4165 0.675005 2.33317L0.666672 17.3332L4.00001 13.9998H15.6667C16.5833 13.9998 17.3333 13.2498 17.3333 12.3332V2.33317C17.3333 1.4165 16.5833 0.666504 15.6667 0.666504ZM14 10.6665H4.00001V8.99984H14V10.6665ZM14 8.1665H4.00001V6.49984H14V8.1665ZM14 5.6665H4.00001V3.99984H14V5.6665Z",
    fill: "#273137"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.83a910ff5a4660e7f7a1a507c5ddc265.svg";
export { ForwardRef as ReactComponent };